<template>
  <div class="signup-review">
    <h1>Signup History</h1>
    <div class="tabs">
      <button @click="view = 'approved'" :class="{ active: view === 'approved' }">Approved</button>
      <button @click="view = 'rejected'" :class="{ active: view === 'rejected' }">Rejected</button>
    </div>

    <p v-if="statusMessage" :class="['status', statusType]">{{ statusMessage }}</p>

    <table v-if="requests.length">
      <thead>
        <tr>
           <th>Name</th><th>Email</th><th>DOB</th><th>Country</th><th>Use</th>
    <th>LE?</th><th>Referral</th><th>Promo</th> <!-- NEW -->
    <th>IP</th><th>User Agent</th>
    <th v-if="view === 'approved'">Approved By</th>
    <th v-if="view === 'approved'">Approved At</th>
    <th v-if="view === 'rejected'">Rejected By</th>
    <th v-if="view === 'rejected'">Rejected At</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="req in requests" :key="req.id">
          <td>{{ req.first_name }} {{ req.last_name }}</td>
          <td>{{ req.email }}</td>
          <td>{{ req.dob }}</td>
          <td>{{ req.country }}</td>
          <td>{{ req.intended_use || '—' }}</td>
          <td>{{ req.law_enforcement_flag ? '✅' : '❌' }}</td>
          <td>{{ req.referral_code || '—' }}</td>
           <td>
      <span v-if="req.promo_code" class="badge badge--promo">{{ req.promo_code }}</span>
      <span v-else>—</span>
    </td>
          <td>{{ req.ip_address }}</td>
          <td><small>{{ req.user_agent }}</small></td>
          <td v-if="view === 'approved'">{{ req.approved_by }}</td>
          <td v-if="view === 'approved'">{{ formatTime(req.approved_at) }}</td>
          <td v-if="view === 'rejected'">{{ req.rejected_by }}</td>
          <td v-if="view === 'rejected'">{{ formatTime(req.rejected_at) }}</td>
        </tr>
      </tbody>
    </table>
<div v-if="total > limit" class="pagination">
  <button @click="prevPage" :disabled="page === 1">Prev</button>
  Page {{ page }} of {{ Math.ceil(total / limit) }}
  <button @click="nextPage" :disabled="page * limit >= total">Next</button>
</div>

    <p v-if="!requests.length">No {{ view }} signups.</p>

    
<router-link to="/signupreview">Signup Review</router-link><br/>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'SignupHistory',
 data() {
  return {
    view: 'approved',
    requests: [],
    statusMessage: '',
    statusType: '',
    page: 1,
    limit: 25,
    total: 0
  };
},
  watch: {
    view() {
      this.fetchData();
    },
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
    const endpoint =
      this.view === 'approved'
        ? `/etherscan/fetch_approved_signups.php?page=${this.page}&limit=${this.limit}`
        : `/etherscan/fetch_rejected_signups.php?page=${this.page}&limit=${this.limit}`;
    axios.get(endpoint, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
    .then((res) => {
      if (res.data.status === 'success') {
        this.requests = res.data.requests;
        this.total = res.data.total;
      } else {
        this.statusMessage = res.data.message;
        this.statusType = 'error';
      }
    })
    .catch(() => {
      this.statusMessage = 'Failed to load data.';
      this.statusType = 'error';
    });
  },
  nextPage() {
    if (this.page * this.limit < this.total) {
      this.page++;
      this.fetchData();
    }
  },
  prevPage() {
    if (this.page > 1) {
      this.page--;
      this.fetchData();
    }
  },
    formatTime(iso) {
      return new Date(iso).toLocaleString();
    },
  },
};
</script>

<style scoped>
.tabs {
  margin-bottom: 10px;
}
.tabs button {
  padding: 6px 10px;
  margin-right: 8px;
  cursor: pointer;
}
.tabs button.active {
  background-color: #3498db;
  color: white;
}
.badge {
  display: inline-block;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  line-height: 1;
  border: 1px solid #ccc;
}
.badge--promo {
  background: #e6f7ff;
  border-color: #91d5ff;
  color: #096dd9;
}

</style>
